import config from "../../config";

const TOUR = "insurance_verification";

const authHeaders = () => {
  const user = JSON.parse(localStorage.getItem("user") || "null");
  const h = { "Content-Type": "application/json" };
  if (user && user.key) h.Authorization = "Token " + user.key;
  return h;
};
const base = () => config.apiGateway.URL;

export const getTourState = async (tour = TOUR) => {
  try {
    const r = await fetch(base() + "/tour/state/?tour_name=" + tour, { headers: authHeaders() });
    return r.ok ? await r.json() : null;
  } catch (e) {
    return null;
  }
};

export const postTourStep = (stepId, currentStep, tour = TOUR) =>
  fetch(base() + "/tour/step/", {
    method: "POST", headers: authHeaders(),
    body: JSON.stringify({ tour_name: tour, step_id: stepId, current_step: currentStep }),
  }).catch(() => {});

export const postTourComplete = (tour = TOUR) =>
  fetch(base() + "/tour/complete/", { method: "POST", headers: authHeaders(), body: JSON.stringify({ tour_name: tour }) }).catch(() => {});

export const postTourSkip = (tour = TOUR) =>
  fetch(base() + "/tour/skip/", { method: "POST", headers: authHeaders(), body: JSON.stringify({ tour_name: tour }) }).catch(() => {});

export const postTourExit = (currentStep, tour = TOUR) =>
  fetch(base() + "/tour/exit/", { method: "POST", headers: authHeaders(), body: JSON.stringify({ tour_name: tour, current_step: currentStep }) }).catch(() => {});

export const postTourRemind = (tour = TOUR) =>
  fetch(base() + "/tour/remind/", { method: "POST", headers: authHeaders(), body: JSON.stringify({ tour_name: tour }) }).catch(() => {});

// Reset the run (replay / resume) so completed/skipped/exited reflect THIS run,
// not an accumulation of every past run.
export const postTourStart = (tour = TOUR) =>
  fetch(base() + "/tour/start/", { method: "POST", headers: authHeaders(), body: JSON.stringify({ tour_name: tour }) }).catch(() => {});

export const ensureTourDemo = async (officeId) => {
  try {
    const r = await fetch(base() + "/clinics/tour/ensure-demo/", {
      method: "POST", headers: authHeaders(), body: JSON.stringify({ office_id: officeId }),
    });
    return r.ok ? await r.json() : null;
  } catch (e) {
    return null;
  }
};

// FTC tour: seed a demo patient + a "Breakdown - Requested" work item in an office
// the FTC user can access, so it surfaces as a demo task in the FTC queue. officeId
// is optional — the backend resolves an accessible office when omitted.
export const ensureFtcTourDemo = async (officeId) => {
  try {
    const r = await fetch(base() + "/clinics/tour/ensure-ftc-demo/", {
      method: "POST", headers: authHeaders(), body: JSON.stringify({ office_id: officeId || null }),
    });
    return r.ok ? await r.json() : null;
  } catch (e) {
    return null;
  }
};
